import { FlexRow, MaterialIcon } from '@gorila-shared-ui/components';
import { Button } from 'baseui/button';
import { memo, useEffect } from 'react';
import { useStyles } from '../../../hooks/useStyles';
import { StyledTooltip } from '../../ui/StyledTooltip';
import { useFleetAssetServices } from '../hooks/useFleetAssetServices';
import FleetAssetSelect from '../shared/FleetAssetSelect';
import { FleetAssetServicesFilters } from './FleetAssetServicesFilters';

function FleetAssetServicesFiltersBar() {
  const { css, theme } = useStyles();
  const { selectedAssetId, onChangeSelectedAssetId, onReload, resetAllFilters } = useFleetAssetServices();

  useEffect(() => {
    return () => {
      resetAllFilters();
    };
  }, []);

  return (
    <FlexRow
      classNames={css({ alignItems: 'center' })}
      gap={theme.sizing.scale100}
    >
      <FlexRow
        classNames={css({ flex: '1', alignItems: 'center' })}
        gap={theme.sizing.scale100}
      >
        <span className={css({ flexGrow: '0.5' })}>
          <FleetAssetSelect
            selectedAssetId={selectedAssetId}
            onChangeAssetId={(assetId) => {
              onChangeSelectedAssetId(assetId);
            }}
            inline
          />
        </span>
        <FleetAssetServicesFilters />
      </FlexRow>
      <StyledTooltip
        content="Recargar tabla"
        showArrow={false}
      >
        <Button
          size="compact"
          shape="square"
          onClick={onReload}
          kind="tertiary"
        >
          <MaterialIcon name="refresh" />
        </Button>
      </StyledTooltip>
    </FlexRow>
  );
}

export default memo(FleetAssetServicesFiltersBar);
